module.exports = __webpack_public_path__ + "static/media/banner@768.5c70a454.png";